import CompensationRequestByBankInputGroup from './CompensationRequestByBankInputGroup'

export default CompensationRequestByBankInputGroup
